<template>
	<div :class="getChartClass" v-scroll="handleScroll">
		<div class="behaviour-chart__wrap">
			<div class="behaviour-chart__chart">

				<div class="behaviour-chart__svg">
					<svg class="pie-chart" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0" y="0" width="193.7" height="193" viewBox="0 0 193.7 193">
					<g v-for="(tab, key) in getTabs" :class="getPieGroupColor(key, false)">
						<path :d="tab.svg.def"/>
					</g>
						<g v-for="(tab, key) in getTabs" v-bind:key="key" :class="getPieGroupActive(key)">
							<transition name="fade">
								<path v-if="isActiveTab(key)" :d="tab.svg.def"/>
							</transition>
							<text :x="tab.svg.x" :y="tab.svg.y" class="text" v-html="formatPercentage(tab.svg.stat/100, 0, false)"></text>
						</g>
					</transition-group>
					</svg>
				</div>

				<ul v-if="isTablet" class="behaviour-chart__legend">
					<li v-for="(tab, key) in getTabs" :class="getLegendClass(key)" v-html="tab.title"></li>
				</ul>

				<div class="behaviour-chart__ctrl">
					<div v-if="isTablet"><Dropdown :class="getColorClass" :data="getDrowdownData" :icon="getDropdownIcon" label="" :selection="getActiveTabSelection" :display="getActiveTabTitle" @dropdownChange="doDropdownChange" /></div>
					<ul v-else class="ctrl-list">
						<li v-for="(tab, key) in getTabs" :class="getTabClass(key)"><span :class="getIconClass(tab)"><Icon :icon="getIconComponent(tab)"/></span><button class="tab-btn" v-html="tab.title" @click="setActiveTab(key)" @focus="setActiveTab(key)"></button></li>
					</ul>
				</div>

			</div>
			<div class="behaviour-chart__content">
				<div class="behaviour-chart__details">
					<div class="behaviour-chart__content-wrap">
						<h3 v-if="!isTablet" v-html="getTitle()"></h3>
						<p v-html="getContentPiece('description')"></p>
					</div>
				</div>
				<div v-if="hasExtraStat()" class="behaviour-chart__stat">
					<div class="behaviour-chart__content-wrap">
						<p><Icon v-if="isTablet" :icon="getDropdownIcon" :class="getColorClass" /><span class="stat" v-html="getStatText()"></span> <span v-html="getContentPiece('stattext')" class="text"></span></p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	import Icon from '@/components/Icon.vue'
	import Dropdown from '@/components/Dropdown.vue'

	export default {

		components: {
			Icon,
			Dropdown,
		},

		data: function() {

			return {

				activeTab: 'hunters',
				tabs: {
					hunters : {
						title: this._translate('m.stages.hunters.title'),
						color: 'red-dark',
						icon: 'SeriousHunters',
						svg: {
							def: 'M96.7,96.7L96.7,96.7L96.7,96.7l85-45.1l0.1-0.1l-0.1-0.1c-17.4-32.7-48-51.1-85.1-51.1C43.4,0.2,0.2,43.4,0.2,96.5v0.2h0.2H96.7z',
							x: 70,
							y: 50,
							stat: 43,
						},
						content: {
							description: this._translate('m.stages.hunters.description'),
							statval: 58,
							stattext: this._translate('m.stages.hunters.stattext'),
						}
					},
					browsing : {
						title: this._translate('m.stages.browsing.title'),
						color: 'red',
						icon: 'JustBrowsing',
						svg: {
							def: 'M96.8,96.8L182,51.6c25,47,7.1,105.4-39.9,130.4c-13.7,7.3-28,11-43.6,11.2L96.8,96.8z',
							x: 127,
							y: 127,
							stat: 35,
						},
						content: {
							description: this._translate('m.stages.browsing.description'),
							statval: 25,
							stattext: this._translate('m.stages.browsing.stattext'),
						}
					},
					started : {
						title: this._translate('m.stages.started.title'),
						color: 'red-light',
						icon: 'GettingStarted',
						svg: {
							def: 'M96.8,96.8l1.7,96.4c-45.2,0.8-83.2-27.8-94.9-71.4L96.8,96.8z',
							x: 40,
							y: 150,
							stat: 20,
						},
						content: {
							description: this._translate('m.stages.started.description'),
							statval: 34,
							stattext: this._translate('m.stages.started.stattext'),
						}
					},
					purchased : {
						title: this._translate('m.stages.purchased.title'),
						color: 'red-lighter',
						icon: 'JustPurchased',
						svg: {
							def: 'M96.8,96.8l-93.2,25c-2.2-8.3-3.3-16.4-3.3-25H96.8z',
							x: 7,
							y: 112,
							stat: 2,
						},
						content: {
							description: this._translate('m.stages.purchased.description'),
						}
					},
				},
				scrolled: false,

			}

		},

		computed: {

			getChartClass: function() {

				var c = 'behaviour-chart fx';

				if ( this.$data.scrolled ) {

					c += ' fx--on';

				}

				return c;

			},

			getTabs: function() {

				return this.$data.tabs;

			},

			getSvgTabs: function() {

				var tabs = {},
				    current = false;

				for ( var key in this.$data.tabs ) {

					if ( key === this.$data.activeTab ) {
						current = key;
 					} else {
						tabs[key] = this.$data.tabs[key];
					}

				}

				return tabs;

			},

			getActiveSvgTabs: function() {

				var tabs = {};

				tabs[this.$data.activeTab] = this.$data.tabs[this.$data.activeTab];

				return tabs;

			},

			getActiveTabTitle: function() {

				return this.$data.tabs[this.$data.activeTab]['title'];

			},

			getActiveTabSelection: function() {

				return this.$data.activeTab;

			},

			getDropdownIcon: function() {

				return this.$data.tabs[this.$data.activeTab]['icon'];

			},

			getColorClass: function() {

				return this.$data.tabs[this.$data.activeTab]['color'];

			},

			getDrowdownData: function() {

				var data = {};

				for ( var key in this.$data.tabs ) {

					data[key] = this.$data.tabs[key]['title'];

				}

				return data;

			},

		},

		methods: {

			getTabClass: function(key) {

				var c = 'tab';
				if ( key === this.$data.activeTab ) {
					c += ' js-active';
				}
				return c;

			},

			getLegendClass: function(key) {

				var c = 'legend legend--' + this.$data.tabs[key].color;
				return c;

			},

			getIconClass: function(tab) {

				var c = 'tab-icon ' + tab.color;
				return c;

			},

			getIconComponent: function(tab) {

				return tab.icon;

			},

			getSvgStatClass: function() {

			},

			getPieGroupColor: function(key) {

				var c = this.$data.tabs[key].color;
				return c;

			},

			getPieGroupActive: function(key) {

				var c = 'stroke';
				if ( this.$data.tabs[key].color === 'red-lighter' ) {
					c += ' invert';
				}
				if ( key === this.$data.activeTab ) {
					c += ' js-active';
				}
				return c;

			},

			getTitle: function() {

				var key = this.$data.activeTab;
				return this.$data.tabs[key].title;

			},

			getStatText: function() {

				var key = this.$data.activeTab;
				return this.formatPercentage(this.$data.tabs[key].content['statval']/100);

			},

			getContentPiece: function(contentKey) {

				var key = this.$data.activeTab;
				return this.$data.tabs[key].content[contentKey];

			},

			setActiveTab: function(key) {

				this.$data.activeTab = key;

			},

			isActiveTab: function(key) {

				return key === this.$data.activeTab;

			},

			hasExtraStat: function() {

				var key = this.$data.activeTab;
				return this.$data.tabs[key].content['statval'];

			},

			doDropdownChange: function(atts) {
				this.setActiveTab(atts.key)
			},

	  	handleScroll: function(e, el) {

	    	var bounding = el.getBoundingClientRect();
				if ( (window.innerHeight - bounding.top) >= (window.innerHeight/3) ) {
					this.$data.scrolled = true;
				};

	  	}

		}

	}

</script>

<style lang="scss">

	$content-width: 21rem;
	$ctrl-width: 16rem;

	.behaviour-chart {

		background: $white;
		box-shadow: $box-shadow;
		margin-bottom: 3rem;

		&.fx {
			opacity: 0;
			transform: translate3d(0, -30px, 0);
			transition: opacity 1s ease, transform 1.2s ease;
		}

		&.fx--on {
			opacity: 1;
			transform: translate3d(0, 0, 0);
		}

	}

	.behaviour-chart__wrap {

		display: flex;
		flex-direction: column;

		@include mq('lap') {
			flex-direction: row;
			overflow: hidden;
		}

	}

	.behaviour-chart__chart {

		@include mq('lap') {
			display: flex;
			width: calc(100% - #{$content-width});
		}

	}

	.behaviour-chart__ctrl {

		position: relative;
		z-index: 2;
		padding: 0 1rem;

		@include mq('lap') {
			width: $ctrl-width;
			padding: 0;
		}

		.dropdown {
			margin: 0 auto;
			max-width: 30rem;
			transform: translate3d(0, 50%, 0);

			&.red-dark { .icon svg { fill: $red-dark; } }
			&.red { .icon svg { fill: $red; } }
			&.red-light { .icon svg { fill: $red-light; } }
			&.red-lighter { .icon svg { fill: $red-lighter; } }

		}

	}

	.behaviour-chart__legend {
		list-style-type: none;
		padding: 0;
		margin: -1rem auto 0;
		padding: 0 1rem;
		width: 100%;
		max-width: 20rem;
		display: flex;
		flex-wrap: wrap;

		li {
			width: 50%;
			font-weight: 600;
			@include typesize('tiny');
			display: flex;
			align-items: center;
			margin-bottom: 1.5em;

			&::before {
				content: '';
				display: inline-block;
				height: 1.5em;
				width: 1.5em;
				background: $red;
				margin-right: .75em;
			}

			&.legend--red-dark::before { background: $red-dark; }
			&.legend--red-light::before { background: $red-light; }
			&.legend--red-lighter::before { background: $red-lighter; }

		}

	}

	.behaviour-chart__svg {

		padding: 3rem calc(3rem - 10px) 3rem 3rem;
		max-width: 400px;
		margin: 0 auto;

		@include mq('lap') {

			display: flex;
			align-items: center;
			justify-content: center;
			width: calc(100% - #{$ctrl-width});

		}

		@include mq('ms') {
			height: 400px;
		}

		svg {
			width: 100%;
			height: auto;
		}

	}

	.ctrl-list {
		list-style-type: none;
		margin: 0;
		padding: 0;
		display: flex;
		flex-direction: column;
		padding-top: 3rem;
		padding-bottom: 3rem;
		justify-content: space-between;
		overflow: hidden;
		padding-left: 10px;
		position: relative;
		z-index: 2;
		height: 100%;

		li {
			padding: 0 0 0 3.25rem;
			position: relative;
			// border: 1px dashed $blue;

			&.js-active {

				.tab-icon {

					width: 3.25rem;

				}

				.icon {
					opacity: 1;
				}

				&::after {
					left: 0;
					box-shadow: $box-shadow;
				}

			}

			&::after {

				content: '';
				display: block;
				position: absolute;
				right: 0;
				top: 0;
				bottom: 0;
				height: 100%;
				left: 100%;
				background: $white;
				box-shadow: 0 0 0 rgba(0, 0, 0, 0), 0 0 0 rgba(0, 0, 0, 0);

				transition: left .7s ease, box-shadow .7s ease;

			}

		}

		.tab-icon {

			background-color: $red;
			width: 1.25rem;
			display: flex;
			position: absolute;
			z-index: 2;
			top: 0;
			right: calc(100% - 3.25rem);
			bottom: 0;
			align-items: center;
			justify-content: center;
			overflow: hidden;

			transition: width .6s ease .1s;

			&.red-dark { background-color: $red-dark; }
			&.red-light { background-color: $red-light; }
			&.red-lighter { background-color: $red-lighter; }

			.icon {

				width: 3.25rem;
				display: flex;
				position: absolute;
				z-index: 2;
				top: 0;
				right: 0;
				bottom: 0;
				align-items: center;
				justify-content: center;
				opacity: 0;

				transition: opacity .3s ease .3s;

			}

			svg {

				fill: $white;
				width: 22px;
				height: 22px;

			}

		}

		.tab-btn {
			appearance: none;
			border: 0;
			background: none;
			padding: 1rem;
			text-align: left;
			outline: none;
			cursor: pointer;
			position: relative;
			z-index: 2;
		}

	}

	.behaviour-chart__content {

		background-color: $mist;
		padding-top: 1rem;

		@include mq('lap') {

			box-shadow: $box-shadow;
			width: $content-width;
			display: flex;
			flex-direction: column;
			justify-content: center;
			padding-top: 0;

			@include mq('ms') {
				display: block;
				height: 380px;
			}

		}

		& > div {
			display: flex;
			flex-direction: column;
			align-items: center;
			font-weight: 300;

			@include mq('ms') {
				display: block;
			}

		}

	}

	.behaviour-chart__content-wrap {
		padding: 1.15rem 1.75rem;
		width: 100%;
		flex: 1;

		p {
			text-align: center;
		}
	}

	.behaviour-chart__details {

		@include mq('lap') {
			background: $white;
			flex: 1;
		}

		h3 {
			width: 100%;
			text-align: center;
		}

		p {
			width: 100%;
		}

	}

	.behaviour-chart__stat {

		p {

			display: flex;
			align-items: center;
			max-width: 40rem;

			@include mq('lap') {
				display: block;
				text-align: center;
			}

			.stat {
				color: $red;
				font-weight: 600;
				display: block;
				margin-right: 1.5rem;
				@include typesize('extra-large');

				@include mq('lap') {
					margin-right: 0;
				}
			}

			.text {

				max-width: 9rem;
				@include mq('lap') {
					max-width: none;
				}

			}

			.icon {

				width: 1.25rem;
				height: 1.25rem;
				margin-right: 1.5rem;

				&.red-dark { svg { fill: $red-dark; } }
				&.red-light { svg { fill: $red-light; } }
				&.red-lighter { svg { fill: $red-lighter; } }

				svg { fill: $red; }

			}

		}

	}

	.pie-chart {

		.text {
			fill: $white;
			font-size: .85em;
			transform-origin: center center;
			transition: transform .3s ease, font-size .3s ease;
			transform: translate(0, 0);

			&.red {
				fill: $red-dark;
			}
		}

		g {

			&.js-active {
				position: relative;
				z-index: 2;

				path {
					stroke: $white;
					stroke-width: 1px;

				}

				.text {
					font-size: 1.5rem;
					transform: translate(-1.5%, 2.5%);
				}
			}

		}

		.red-lighter { fill: $red-lighter; }
		.red-light { fill: $red-light; }
		.red { fill: $red; }
		.red-dark { fill: $red-dark; }

		.stroke {
			fill: none;

			&.invert {

				.text {
					fill: $red-dark;
				}

			}

		}

	}

</style>